import { z } from 'zod'
import type { CheckIdCodeRequest } from '@/models/api/check-id-code-request'
import {
  corporateNameSchema,
  type CorporateName
} from '@/models/api/corporate-name'
import type { GetCorporateNameByIdentifierRequest } from '@/models/api/get-corporate-name-by-identifier-request'
import {
  apiValidator,
  type ApiFactory,
  type ApiResponse
} from '~library/services'

export default class CorporateApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 檢驗客戶識別碼
   * https://hackmd.io/_Xam1FfQQlGEmlPKXWP29A
   */
  @apiValidator(z.null())
  checkIdCode(data: CheckIdCodeRequest): Promise<ApiResponse<null>> {
    return this.api.post('Corporate/CheckIdCode', data, {
      headers: {
        ignoreRtnCodeError: ['212', '213']
      }
    })
  }

  /**
   * API 取得客戶資料by識別碼
   * https://hackmd.io/z4w6AbyVR8y-af_Mts5yXA
   */
  @apiValidator(corporateNameSchema)
  getCorporateNameByIdentifier(
    data: GetCorporateNameByIdentifierRequest
  ): Promise<ApiResponse<CorporateName>> {
    return this.api.post('Corporate/GetCorporateNameByIdentifier', data)
  }
}
